import React from "react";
import { ADMIN_TABS } from "./adminConstants";

const AdminNav = ({ t, activeTab, onSelectTab, navRef }) => (
  <aside
    className="admin-nav"
    aria-label={t("admin.nav.label", "Admin navigation")}
    ref={navRef}
  >
    <div className="admin-nav__brand">
      <span className="admin-nav__title">{t("admin.nav.title", "Wayli Owner")}</span>
      <span className="admin-nav__subtitle">
        {t("admin.nav.subtitle", "Control room")}
      </span>
    </div>
    <nav className="admin-nav__list" role="tablist">
      {ADMIN_TABS.map((tab) => (
        <button
          key={tab.id}
          type="button"
          role="tab"
          aria-selected={activeTab === tab.id}
          className={`admin-nav__item ${
            activeTab === tab.id ? "admin-nav__item--active" : ""
          }`.trim()}
          onClick={() => onSelectTab(tab.id)}
        >
          {t(tab.labelKey, tab.labelFallback)}
        </button>
      ))}
    </nav>
  </aside>
);

export default AdminNav;
